import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import BgImg from "../../../images/solution/automotive-updated/high-impact.webp";

function Logisticsoperation() {
  return (
    <section
      className="streamline_cloud p-100"
      style={{
        backgroundImage: `url(${BgImg})`,
        backgroundPosition: "center top",
      }}
    >
      <Container>
        <Row>
          <Col xs={12} md={7} lg={6} xl={5} xxl={5}>
            <h2>
              Build <span>High-Impact</span> Automotive Apps
            </h2>
            <p>
              Develop scalable automotive apps for smart navigation, electric
              vehicle management, and more.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
            >
              Build Future-Ready Apps
            </Link>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Logisticsoperation;
